export type UpdateTagErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class UpdateTagError extends Error {
    code: UpdateTagErrorCode;

    constructor(code: UpdateTagErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
